import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Box, Button, Container, TextField, Typography } from '@mui/material';
import { useTranslation } from "react-i18next";

export default function ResetPassword() {
    const { t, i18n } = useTranslation();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');

    /**
     * Listen for language changes from Electron menu
     */
    useEffect(() => {
        if (window.electronAPI?.language) {
            console.log('[PasswordReset] Setting up Electron language listener');
            const cleanup = window.electronAPI.language.onChange((newLanguage) => {
                console.log('[PasswordReset] Language change received from Electron:', newLanguage);
                i18n.changeLanguage(newLanguage);
            });
            
            return cleanup; // Cleanup on unmount
        }
    }, [i18n]);

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (password !== confirmPassword) {
            setError(t('passwordsDoNotMatch'));
            return;
        }

        const email = searchParams.get('email');
        const code = searchParams.get('code');

        try {
            const response = await axios.post(`${process.env.REACT_APP_FIREBASE_API_HOST}/api/auth/reset/password`, {
                email,
                code,
                password,
            });

            const { status } = response.data;

            if (status === 'SUCCESS') {
                alert(t('passwordResetSuccessfully'));
                navigate('/login'); // Redirect to login page
            } else if (status === 'NO_LINK_FOUND') {
                alert(t('passwordResetExpired'));
            } else if (status === 'CODE_USED') {
                alert(t('passwordResetCodeUsed'));
            } else {
                alert(t('passwordResetUnexpectedError'));
            }
        } catch (error) {
            console.error('Error resetting password:', error);
            alert(t('passwordResetCodeUsed'));
        }
    };

    return (
        <Container component="main" maxWidth="xs">
            <Box
                className={"white-background"}
                sx={{
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <Typography component="h1" variant="h5">
                    {t('resetPassword')}
                </Typography>
                <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label={t('password')}
                        type="password"
                        id="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="confirmPassword"
                        label={t('confirmPasswordReset')}
                        type="password"
                        id="confirmPassword"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        error={!!error}
                        helperText={error}
                    />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{ mt: 3, mb: 2 }}
                    >
                        {t('resetPassword')}
                    </Button>
                </Box>
            </Box>
        </Container>
    );
}
